export default __webpack_public_path__ + "static/media/gasag_s3.9d810528.png";